export default __webpack_public_path__ + "static/R2_Add-on-2847da0638850fa91d8c81982026327f.mp4";